import { Component, OnInit, ViewEncapsulation } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { Subscription } from "rxjs";
import { GeneralStore } from "../../../../../services/store/general";
import { APPLICATIONS_ERROR, MCFormatTextPipe } from "@maslul/common-services";


@Component({
    selector: 'mi-error',
    imports: [
        MCFormatTextPipe
    ],
    templateUrl: './error.html',
    styleUrl: './error.scss',
    standalone: true,
    encapsulation: ViewEncapsulation.None,

})
export class ErrorComponent implements OnInit {
    subscribtion: Subscription = new Subscription();
    errorText: any;
    errorPageCode!: APPLICATIONS_ERROR;

    constructor(
        private translateService: TranslateService,
        private generalStore: GeneralStore
    ) {

    }


    ngOnInit() {
        this.initText();
        this.init();
    }


    initText() {

        this.subscribtion.add(this.translateService.stream('error').subscribe(translation => {
            this.errorText = translation;
        }));

    }

    init() {
        this.errorPageCode = this.generalStore.getSnapshot().errorPageCode;
    }
}


